<template>
  <div>
    <CModal
      backdrop="static"
      :visible="visible"
      :close-on-backdrop="false"
      class="p-0 d-block"
      add-content-classes="left-top-header"
    >
      <div class="kiosk-active-pass-content position-relative px-2 pt-4 pb-5">
        <CRow v-if="activePass" class="justify-content-center">
          <CCol v-if="passLimit && passLimit.has" md="9 d-flex flex-column">
            <div class="text-center text-value-lg">
              Pass Limit from
              {{
                passLimit.from_date
                  ? $helpers.transformDate(passLimit.from_date, "MM/DD/YYYY")
                  : ""
              }}
              to
              {{
                passLimit.to_date
                  ? $helpers.transformDate(passLimit.to_date, "MM/DD/YYYY")
                  : ""
              }}
            </div>

            <div class="text-center">
              <div class="bg-red text-center text-value d-inline-block p-2">
                Pass Remaining
                {{
                  passLimit.max > passLimit.current
                    ? passLimit.max - passLimit.current
                    : 0
                }}/{{ passLimit.max == -1 ? "&infin;" : passLimit.max }}
              </div>
            </div>
          </CCol>

          <CCol md="9" class="d-flex flex-column px-2">
            <div
              v-if="activePass.approved_by"
              class="text-graident-blue text-value-lg my-4"
            >
              Your pass is approved.
            </div>
            <div v-else class="text-graident-blue text-value-lg my-4">
              {{ activePass.created_by_user.first_name }}
              {{ activePass.created_by_user.last_name }}, your pass is created
              and is awaiting approval from your teacher's dashboard or this
              Kiosk.
            </div>
            <div class="bg-light p-3 text-dark">
              <h5 class="mb-3">
                {{
                  $helpers.transformDate(
                    activePass.created_at,
                    "dddd, DD, MMMM, YYYY"
                  )
                }}
              </h5>
              <table class="w-100 text-start">
                <tr>
                  <th>Time</th>
                  <th>From</th>
                  <th>To</th>
                </tr>
                <tr>
                  <td>
                    {{
                      $helpers.transformDate(activePass.created_at, "h:mm A")
                    }}
                  </td>
                  <td>{{ activePass.from ? activePass.from.name : "" }}</td>
                  <td>{{ activePass.to ? activePass.to.name : "" }}</td>
                </tr>
              </table>
            </div>
          </CCol>

          <CCol
            v-if="!isAutoPass"
            md="9"
            class="text-start d-flex flex-column mt-3"
          >
            <div v-if="!activePass.approved_at">
              <h4 class="text-center mb-3 mt-0">Staff use only</h4>
              <CFormInput
                v-model="teacherPin"
                v-noautofill
                placeholder="Enter your PIN"
                :class="{
                  'is-invalid':
                    v$.teacherPin.$error ||
                    (responseMessageTeacherApproval &&
                      responseMessageTeacherApproval.message == 'Invalid pin.')
                }"
                type="password"
                @update:model-value="responseMessageTeacherApproval = null"
              >
              </CFormInput>
              <div>
                <div
                  v-if="v$.teacherPin.$error && v$.teacherPin.required.$invalid"
                  class="invalid-feedback"
                >
                  This field is required
                </div>
                <div
                  v-if="
                    v$.teacherPin.$error && v$.teacherPin.minLength.$invalid
                  "
                  class="invalid-feedback"
                >
                  The pin should be at least 4 characters.
                </div>
                <div
                  v-if="
                    v$.teacherPin.$error && v$.teacherPin.maxLength.$invalid
                  "
                  class="invalid-feedback"
                >
                  The pin may not be greater than 6 characters.
                </div>
                <div
                  v-if="
                    responseMessageTeacherApproval &&
                    responseMessageTeacherApproval.message == 'Invalid pin.'
                  "
                  class="invalid-feedback text-red"
                >
                  INVALID PIN. This attempt has been logged and reported. For
                  security purposes, you will be logged out after repeated
                  INVALID PINs.
                </div>
              </div>
              <CAlert
                class="mt-2"
                v-if="reqResponse.message"
                :color="reqResponse.type"
                :show="!!reqResponse.message"
              >
                {{ reqResponse.message }}
              </CAlert>
            </div>
            <div
              class="d-flex w-100 py-3 align-items-center justify-content-center stuff-only-popup-buttons"
            >
              <button
                v-if="!activePass.approved_at"
                class="btn btn-cancel px-2 py-3 w-100"
                @click="cancelPass()"
              >
                Cancel
              </button>
              <button
                :class="{ 'w-100': !activePass.approved_at }"
                class="btn bg-gray text-white mx-2"
                @click="cancel(), logOutUser()"
              >
                Close({{ timeoutCounter }})
              </button>
              <button
                v-if="currentStatus == 'waiting' && !activePass.parent"
                class="btn btn-comfirm px-2 py-3 w-100 text-center justify-content-center"
                @click="updatePassStuff(actions.approved)"
              >
                APPROVE
              </button>
            </div>
          </CCol>
          <CCol v-else md="9 d-flex flex-column" class="text-start mt-4 px-2">
            <CAlert
              class="mt-0"
              v-if="reqResponse.message"
              :color="reqResponse.type"
              :show="!!reqResponse.message"
            >
              {{ reqResponse.message }}
            </CAlert>
            <div
              class="d-flex w-100 align-items-center justify-content-center stuff-only-popup-buttons"
            >
              <button
                v-if="!activePass.approved_at"
                class="btn btn-cancel px-2 py-3 w-100"
                @click="cancelPass()"
              >
                Cancel
              </button>
              <button
                :class="{ 'w-100': !activePass.approved_at }"
                class="btn bg-gray text-white mx-2"
                @click="cancel(), logOutUser()"
              >
                Close({{ timeoutCounter }})
              </button>
              <button
                v-if="isStartingAutoPassAllowed"
                class="btn btn-comfirm no-icon kiosk-start-btn px-2 py-3 w-100 text-center justify-content-center"
                @click="autoApprovePass()"
              >
                START
                <span class="ms-2 d-flex"
                  ><span class="fi flaticon-play-circle"
                /></span>
              </button>
            </div>
          </CCol>
        </CRow>
        <Loader
          :is-processing="!activePass || isLoading"
          classes="position-absolute"
        />
        <div
          class="active-pass-history-badge text-white"
          @click="showHistoryModal = true"
        >
          {{ passHistories && passHistories.length }}
        </div>
      </div>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
    <CModal
      backdrop="static"
      :visible="showHistoryModal"
      :close-on-backdrop="false"
      class="p-0"
      size="lg"
      add-content-classes="no-padding-modal no-border-radius-modal left-top-header history-modal"
    >
      <div
        class="pt-4 px-3 create-popup-header d-flex justify-content-between align-items-center w-100"
      >
        <div
          class="d-inline-block bg-gradient-blue text-white rounded-circle p-1 lh-normal cursor-pointer"
          @click="showHistoryModal = false"
        >
          <span class="close-icon" />
        </div>
      </div>
      <div>
        <StudentPassHistory v-if="passHistories" :options="passHistories" />
      </div>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
  </div>
</template>

<script>
import moment from "moment-timezone"
import { mapGetters } from "vuex"
import useVuelidate from "@vuelidate/core"
import { maxLength, minLength, required } from "vuelidate/lib/validators"

import Loader from "@/components/Loader"
import StudentPassHistory from "@/components/DataTables/StudentPassHistory"
import Echo from "laravel-echo"
let EchoInstance = null
export default {
  name: "KioskActivePass",
  components: {
    Loader,
    StudentPassHistory
  },
  emits: ["cancel"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      interval: null,
      timeout: 120,
      visible: false,
      passStatuses: {
        waiting: "Waiting Approval",
        approved: "Active",
        expired: "Ended",
        canceled: "Canceled"
      },
      showHistoryModal: false,
      actions: {
        approved: 1,
        end: 2,
        arrived: 3,
        returning: 4,
        cancel: 5
      },
      counter: 1,
      showStuffModal: false,
      teacherPin: "",
      teacherNote: "",
      responseMessageTeacherApproval: null,
      responseMessageRoomApproval: null,
      modalAction: 1,
      isLoading: false,
      updatePassHistory: true,
      showCheckInModal: false,
      showCancelModal: false,
      roomPin: "",
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    teacherPin: {
      required,
      maxLength: maxLength(6),
      minLength: minLength(4)
    },
    roomPin: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(6)
    },
    teacherNote: {
      maxLength: maxLength(255)
    }
  },
  computed: {
    ...mapGetters({
      activePass: "kiosks/activePass",
      passHistories: "kiosks/passHistories",
      activeKiosk: "kiosks/activeKiosk",
      passLimit: "passes/pass_limit"
    }),
    timeInPass() {
      return this.counter && this.activePass
        ? this.$helpers.secondsToTimeString(
            moment().diff(
              this.activePass.parent && this.activePass.parent.approved_at
                ? moment(this.activePass.parent.approved_at)
                : this.activePass.approved_at
                ? moment(this.activePass.approved_at)
                : moment(),
              "seconds"
            )
          )
        : ""
    },
    currentStatus() {
      if (
        this.activePass &&
        this.activePass.pass_status == 1 &&
        this.activePass.approved_at === null &&
        !this.activePass.parent
      ) {
        return "waiting"
      }
      if (
        this.activePass &&
        this.activePass.pass_status == 1 &&
        this.activePass.approved_at === null &&
        this.activePass.parent
      ) {
        return "approved"
      }
      if (
        this.activePass &&
        this.activePass.pass_status == 1 &&
        this.activePass.approved_at !== null &&
        this.activePass.completed_at === null
      ) {
        return "approved"
      }
      return "expired"
    },
    isLayoverPass() {
      return this.activePass &&
        (this.activePass.to_type == "App\\Models\\User" ||
          (this.activePass.to && this.activePass.to.trip_type == "Layover"))
        ? true
        : false
    },
    timeoutCounter() {
      return moment.utc(this.timeout * 1000).format("mm:ss")
    },
    isAutoPass() {
      return (
        this.activePass &&
        this.activePass.flags &&
        this.activePass.flags.auto_pass &&
        this.activePass.flags.auto_pass.is_valid
      )
    },
    isStartingAutoPassAllowed() {
      return (
        this.isAutoPass &&
        !this.activePass.approved_at &&
        (this.activePass.flags.auto_pass.mode == "start_and_stop" ||
          this.activePass.flags.auto_pass.mode == "start_only")
      )
    }
  },
  watch: {
    currentStatus: function () {
      if (this.currentStatus == "expired") {
        this.cancel()
      }
    },
    activePass: function (pass) {
      if (
        Object.prototype.hasOwnProperty.call(pass, "created_at") &&
        pass.created_at
      ) {
        this.initTimeout()
      }
    }
  },
  created() {
    if (this.activePass) {
      this.initTimeout()
      this.initSockets()
    }
  },
  mounted() {
    this.visible = true
  },
  unmounted() {
    clearInterval(this.interval)
    this.visible = false
  },
  methods: {
    closeCheckInModal() {
      this.roomPin = ""
      this.showCheckInModal = false
      this.v$.$reset()
    },
    closeCancelModal() {
      this.showCancelModal = false
    },
    checkIfValid(fieldName) {
      const field = this.v$[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !field.$invalid
    },
    cancelPass() {
      if (window.confirm("Are you sure you want to cancel this pass?")) {
        this.isLoading = true
        this.resetResponseMessages()
        if (this.activePass) {
          const data = {
            id: this.activePass.id,
            data: {
              action: 8,
              kiosk_id: this.activeKiosk.id
            }
          }
          this.$store
            .dispatch("kiosks/updatePass", data)
            .then(() => {
              this.isLoading = false
              this.setSuccessResponse("Your pass has successfully been ended.")
              setTimeout(() => {
                this.resetResponseMessages()
                this.cancel()
              }, 1000)
            })
            .catch((err) => {
              const response = err.response.data
              this.setErrorResponse(response.message, response.errors)
              this.isLoading = false
            })
        }
      }
    },
    closeHistoryModal() {
      this.showHistoryModal = false
    },
    closeStuffModal() {
      this.showStuffModal = false
      this.responseMessageTeacherApproval = null
      this.teacherPin = ""
      this.teacherNote = ""
      this.v$.$reset()
    },
    openStuffModal(attr) {
      this.v$.$reset()
      this.modalAction = attr
      this.showStuffModal = true
    },
    updatePassStuff(argAction, returnType) {
      this.resetResponseMessages()
      this.v$.$touch()
      if (
        !this.checkIfValid("teacherPin") ||
        !this.checkIfValid("teacherNote")
      ) {
        return
      }
      this.isLoading = true
      this.updatePassHistory = false
      const elem = {
        id: this.activePass.id,
        data: {
          teacher_pin: this.teacherPin,
          approval_message: this.teacherNote,
          action: argAction,
          kiosk_id: this.activeKiosk.id
        }
      }
      if (returnType) {
        elem.data.return_type = returnType
      }

      this.$store
        .dispatch("kiosks/updatePass", elem)
        .then((res) => {
          this.$store.commit("kiosks/SET_ACTIVE_PASS", res.data.data)
          this.isLoading = false
          this.setSuccessResponse("Your pass has successfully been approved.")
          setTimeout(() => {
            this.resetResponseMessages()
            this.v$.$reset()
            this.cancel()
            // this.logOutUser();
          }, 1000)
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            this.cancel()
          }
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    autoApprovePass() {
      this.isLoading = true
      const data = {
        passId: this.activePass.id,
        action: 1,
        kiosk_id: this.activeKiosk.id
      }
      this.$store
        .dispatch("kiosks/autoApprovePass", data)
        .then((res) => {
          this.$store.commit("kiosks/SET_ACTIVE_PASS", res.data.data)
          this.isLoading = false
          this.setSuccessResponse("Your pass has successfully been approved.")
          setTimeout(() => {
            this.resetResponseMessages()
            this.cancel()
          }, 1200)
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            this.cancel()
          }
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    initTimeout() {
      if (!this.interval) {
        this.interval = setInterval(() => {
          if (this.timeout > 0) {
            this.timeout--
          } else {
            clearInterval(this.interval)
            this.cancel()
            this.logOutUser()
          }
        }, 1000)
      }
    },
    initSockets() {
      if (process.env.VUE_APP_SOCKET_PROVIDER == "PUSHER") {
        window.Pusher = require("pusher-js")
        EchoInstance = new Echo({
          broadcaster: "pusher",
          authEndpoint: `${process.env.VUE_APP_AUTH_URL}/api/v5/broadcasting/auth`,
          key: process.env.VUE_APP_PUSHER_APP_KEY,
          cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
          auth: {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("kioskAccessToken")
            }
          },
          forceTLS: true
        })
      } else {
        window.io = require("socket.io-client")
        EchoInstance = new Echo({
          broadcaster: "socket.io",
          host: process.env.VUE_APP_WS_HOST,
          authEndpoint: `${process.env.VUE_APP_AUTH_URL}/api/v5/broadcasting/auth`,
          encrypted: process.env.VUE_APP_WS_ENCRYPTED === "true",
          auth: {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("kioskAccessToken")
            }
          },
          transports: ["websocket"]
        })
      }
      window.kioskChannel = EchoInstance.private(
        `kiosks.user.${this.activePass.user_id}`
      )
      window.kioskChannel.listen("PassApproved", (payload) => {
        if (payload && payload.pass) {
          this.$store.commit("kiosks/SET_ACTIVE_PASS", payload.pass)
        }
      })
    },
    destroySockets() {
      if (process.env.VUE_APP_SOCKET_PROVIDER == "PUSHER") {
        window.kioskChannel.subscription.unbind_all()
      } else {
        window.kioskChannel.unsubscribe()
      }
    },
    cancel() {
      this.destroySockets()
      clearInterval(this.interval)
      this.$emit("cancel")
    },
    logOutUser() {
      this.$store.dispatch("kiosks/userLogout")
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }
  }
}
</script>
